import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        button: css`
            ${custom.button};
            padding: 0;
        `,
        root: css`
            ${common.fullContainer};
            display: flex;
            flex-direction: column;
        `,
    }
}

export default styles
